<template>
    <button @click="handleClick">
      {{ value }}
    </button>
</template>
<script>
    export default {
      data () {
        return {
        }
      },
      computed: {
        value () {
          return (this.shiftEnabled) ? this.shiftKey : this.normalKey
        }
      },
      props: ['normalKey', 'shiftKey', 'shiftEnabled'],
      methods: {
        handleClick () {
          this.$emit('click', this.value)
        }
      }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/key-button.vue